<template>
    <div>
        <template v-if="crud_vendor === true && crud_vendor !== null">
            <div>

                <div class="modal fade" id="paySingleVendor" tabindex="-1" role="dialog" aria-labelledby="payVendorLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <div class="modal-body pay-vendor-popup p-0">
                                <div class="popup-head clearfix">
                                    <h2 class="float-left"> Vendor Payment Details </h2>
                                   
                                </div>
                                <div class="popup-head clearfix">
                                  <div class="form-group">
                                    <div class="row">
                                        <div class="col">
                                            <input type="text" class="form-control" name="batch_name" id="batch_name" placeholder="What would you like to call this batch." autocomplete="off"/>
                                        </div>
                                        <div class="col">
                                            <button class="btn btn-primary float-right createBatch" id="createBatch" @click="createBatch('dt-vendor-paySingle')"> Create Batch </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div class="table-holder pay-table-holder">
                                    <table id="dt-vendor-paySingle" class="table table-responsive-xl m-0" style="width:100%">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Account Title</th>
                                            <th>Account Number</th>
                                            <th>Amount</th>
                                            <th>Purpose of Payment</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="">
                                                <div class="image-title">
                                                    <div class="image-holder">
                                                        <img src="/images/table-dummy-image.jpg" alt="" />
                                                    </div>
                                                    Jawad Amjad
                                                </div>
                                            </td>
                                            <td> Food </td>
                                            <td> <input type="text" class="form-control number-field" name="" placeholder="Type Amount" autocomplete="off" /> </td>
                                            <td> <input type="text" class="form-control" name="" placeholder="Type Purpose Of Payment"  autocomplete="off" /> </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!--Vendor Pay Modal -->
                <div class="modal fade" id="payVendor" tabindex="-1" role="dialog" aria-labelledby="payVendorLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <div class="modal-body pay-vendor-popup p-0">
                                <div class="popup-head clearfix">
                                    <h2 class="float-left"> Vendor Payment Details </h2>
                                </div>
                            <div class="popup-head clearfix">
                                  <div class="form-group">
                                    <div class="row">
                                        <div class="col">
                                            <input type="text" class="form-control" name="batch_name_" id="batch_name_" placeholder="What would you like to call this batch." autocomplete="off"/>
                                        </div>
                                        <div class="col">
                                            <button class="btn btn-primary float-right createBatch" id="createBatch" @click="createBatch('dt-vendor-pay')"> Create Batch </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div class="table-holder pay-table-holder">
                                    <table id="dt-vendor-pay" class="table table-responsive-xl m-0" style="width:100%">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Account Title</th>
                                            <th>Account Number</th>
                                            <th>Amount</th>
                                            <th>Purpose of Payment</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="">
                                                <div class="image-title">
                                                    <div class="image-holder">
                                                        <img src="/images/table-dummy-image.jpg" alt="" />
                                                    </div>
                                                    Jawad Amjad
                                                </div>
                                            </td>
                                            <td> Food </td>
                                            <td> <input type="text" class="form-control number-field" name="" placeholder="Type Amount" autocomplete="off"/> </td>
                                            <td> <input type="text" class="form-control" name="" placeholder="Type Purpose Of Payment" autocomplete="off" /> </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!--Vendor Pay Modal end -->


                <div class="page-top mb-1 mb-3 clearfix">
                    <div class="page-top mb-3 clearfix">
                        <div class="form-group float-left selection-custom-dropdown m-0 w-25">
                            <div class="form-control dropdown">
                                <label class="check-holder">
                                    <input id="selectAllcheck" type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <a class="drop-value-changer" data-offset="0,5" data-toggle="dropdown" href="javascript:void(0)">
                                    Select Category <span class="caret"></span>
                                </a>
                                <div class="dropdown-menu">
                                    <ul class="list">
                                        <li class="dropdown-item"> <a class="dropdown-link all" href="javascript:void(0)" @click="selectDTRows('All',$event.currentTarget)"> All </a></li>
                                        <li class="dropdown-item" v-for="category in vendorCategories" v-bind:value="category.id" v-bind:key="category.id"><a class="dropdown-link" href="javascript:void(0)" @click="selectDTRows(category.name, $event.currentTarget)"> {{category.name}}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <router-link to="/addVendorPersonalDetail" class="btn btn-primary float-right"> Add Vendor</router-link>
                        <router-link to="/vendorPaymentBulkUpload"  class="btn btn-primary float-right mr-1"> Bulk Upload </router-link>
                        <a href="#" id="btnPaymentTop" class="btn btn-primary hide float-right mr-1" data-toggle="modal" data-target="#payVendor"> <i class="fal fa-cloud-upload"></i> Pay </a>
                        <input type="text" name="" id="customSearch" @keyup="searchData()" class="form-control float-right w-25 mr-1" placeholder="Search" />
                    </div>

                </div>

                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
                            <table id="dt-vendors-list" class="table table-responsive-xl" style="width:100%">
                                <thead>
                                <tr>
                                    <th class="pr-0" style="width: 15px !important"></th>
                                    <th style="display: none;"></th>
                                    <th style="display: none;"></th>
                                    <th>Name</th>
                                    <th>Account Type</th>
                                    <th>Account No.</th>
                                    <th>Category</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="vendor in data" v-bind:key="vendor.id">
                                    <td class="pr-0">
                                        <input type="checkbox" :id="vendor.id" :value="vendor.id">
                                    </td>
                                    <td style="display: none;">{{vendor.id}}</td>
                                    <td style="display: none;" v-if="vendor.default_beneficiary != null">{{vendor.default_beneficiary.account_title}}</td>
                                    <td>{{ vendor.name }}</td>
                                    <td v-if="vendor.default_beneficiary != null"> {{vendor.default_beneficiary.account_type}} </td>
                                    <td v-if="vendor.default_beneficiary != null">{{vendor.default_beneficiary.account_number}}</td>
                                    <td v-if="vendor.default_beneficiary == null"> ---- </td>
                                    <td v-if="vendor.category != null">{{ vendor.category.name}}</td>
                                    <td v-if="vendor.category == null">----</td>
                                    <td class="text-center"> <a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Pay" class="btn btn-primary"> Pay </a></td>
                                </tr>
                            </tbody>
                            </table>
                    </div>
                </div>
            </div>

        </template>

        <template v-else-if="crud_vendor === null">
            <preLoader></preLoader>
        </template>

        <template v-else-if="crud_vendor === false && crud_vendor !==null">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
     var completeTable = null;
    export default {
        data() {
            return {
                data : null,
                complete_profile_count : '',
                incomplete_profile_count : '',
                vendorCategories : '',
                checked:null,
                vendrs:null,
                crud_vendor:null
            };
        },
        mounted() {
            this.can("crud_vendor")
            .then(result => {
                this.crud_vendor = result.crud_vendor;
            })
            .then(result => {
                if (this.crud_vendor === true) {
                var that = this;
                that.getVendorData();
                that.categories();
            }
      });


        },
        created() {

        },
        methods: {
            getVendorData(){
                this.$Progress.start();
                axios.get("/api/listVendors")
                .then(res => {
                    if(res.status == 200){
                        this.data = res.data.records;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .then(res => {
                   this.vendorPayments();
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },
            vendorPayments(){
                var that = this;
                completeTable = $('#dt-vendors-list').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    "select": true,
                    "searching":true,
                    columnDefs: [ {
                        orderable: false,
                        className: 'select-checkbox',
                        targets:   0
                    } ],
                    select: {
                        style:    'multi',
                        selector: 'td:first-child'
                    },
                    order: [[ 0, "desc" ]],
                });

                $(document).ready(function(){
                    $('#selectAllcheck').on('change', function(){
                        if ($(this).prop('checked')) {
                            $('.list .dropdown-link').addClass('searched');
                            completeTable.rows().select();
                            $(this).parent().siblings('.drop-value-changer').html("All");
                        }else{
                            $('.list .dropdown-link').removeClass('searched');
                            completeTable.rows().deselect();
                            $(this).parent().siblings('.drop-value-changer').html("Select Category");
                        }
                    });

                    $('.list a').click(function(event){
                        event.stopPropagation();
                    });


                    completeTable.on( 'select', function ( e, dt, type, indexes ) {
                        var data = completeTable.rows('.selected').data();
                        that.vendrs = [];
                        for(var i = 0; i < data.length; i++){
                            var user = data[i];
                            var value = user[1];
                            that.vendrs.push(value);
                        }
                        var cRow = completeTable[type](indexes).nodes().to$();
                        var ele = $(cRow).find(":checkbox");
                        ele.prop('checked', true);
                        $("#btnPaymentTop").show();
                        var tRows = completeTable.rows().eq(0).length;
                        var totalRow = completeTable.rows().data().length;
                        var cRowSelected = completeTable.rows('.selected').data().length;
                        if (cRowSelected == tRows) {
                            $(".check-holder input").prop("checked", true);
                        }
                        if (cRowSelected === totalRow) {
                            $(".check-holder input").prop("checked", true);
                        }
                    } );
                    completeTable.on( 'deselect', function ( e, dt, type, indexes ) {
                        var data = completeTable.rows( indexes ).data();
                        var id = data[0][1];
                        that.vendrs.splice( $.inArray(id,that.vendrs), 1);

                        var cRow  = completeTable[ type ]( indexes ).nodes().to$();
                        var ele = $(cRow).find(":checkbox");
                        ele.prop('checked', false);
                        var totalRow = completeTable.rows().data().length;
                        var cRowSelected = completeTable.rows('.selected').data().length;
                        if (cRowSelected < totalRow) {
                            $(".check-holder input").prop("checked",false);
                        }
                        if(cRowSelected == 0){
                            $("#btnPaymentTop").hide();
                        }else{
                            $("#btnPaymentTop").show();
                        }

                    });


                    $('#dt-vendors-list tbody').on('click', 'td a', function (){
                        var data = completeTable.row($(this).parent().parent()).data();
                        $(this).parent().parent().addClass('selected');
                        $('table#dt-vendor-paySingle').find('tbody').html('');

                            var user = data;
                            var value = user[1];
                            var html = '<tr>';
                            var html = '<tr>';
                            html += '<td>' + user[3] + '</td>';
                            html += '<div class="image-title">';
                            html += '<div class="image-holder">';
                            html += '<img src="assets/images/table-dummy-image.jpg" alt="" />';
                            html += '</div></td>';
                            html += '<td>' + user[2] + '</td>';
                            html += '<td>' + user[5] + '</td>';
                            html += '<td><input class="form-control number-field vendors" type="hidden" name="vendor[]" value="' + value + '"/><input type="text" name="amount[]" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="Type Amount"  class="form-control number-field amount" autocomplete="off"></td>';
                            html += '<td><input type="text" name="purpose[]" placeholder="Type Purpose Of Payment" class="form-control purpose"  autocomplete="off"></td>';
                            html += '</tr>';
                            $('table#dt-vendor-paySingle').append(html);
                        $('.createBatch').prop('disabled',false);
                        $('#paySingleVendor').modal('show');

                    });

                    $('#btnPaymentTop').on('click', function (){
                        var data = completeTable.rows('.selected').data();
                        $('table#dt-vendor-pay').find('tbody').html('');
                        for (var i = 0; i < data.length; i++) {
                            var user = data[i];
                            var value = user[1];
                            console.log(user);
                            var html = '<tr>';
                            html += '<td>' + user[3] + '</td>';
                            html += '<div class="image-title">';
                            html += '<div class="image-holder">';
                            html += '<img src="assets/images/table-dummy-image.jpg" alt="" />';
                            html += '</div></td>';
                            html += '<td>' + user[2] + '</td>';
                            html += '<td>' + user[5] + '</td>';

                            html += '<td><input class="form-control number-field vendors" type="hidden" name="vendor[]" value="' +value+ '"/><input type="text" name="amount[]" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="Type Amount"  class="form-control number-field amount"></td>';
                            html += '<td><input type="text" name="purpose[]" placeholder="Type Purpose Of Payment" class="form-control purpose"></td>';
                            html += '</tr>';
                            $('table#dt-vendor-pay').append(html);
                        }
                        $('.createBatch').prop('disabled',false);
                        $('#payVendor').modal('show');
                    });
                });
            },

            categories(){
                axios.get('/api/vendorCategories', {
                })
                .then(res => {
                    if(res.status == 200){
                        this.vendorCategories = res.data;
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load data'
                    });
                });
            },
            createBatch(table){
                let that = this;
                $('.createBatch').prop('disabled',true);
                this.$Progress.start();
                var vendors = [];

                var amount = [];
                var purpose = [];
                var flag = 0;
                var tb = $("#"+table);
                $("#"+table+' tbody tr').each(function() {
                    var record = $(this).find("input");
                    record.each(function(){
                        if($(this).hasClass("vendors")){
                            if ($(this).val() == '' || $(this).val() == 0) {
                                swal.fire({
                                        type: 'error',
                                        title: 'Vendor not found'
                                    });
                                $('.createBatch').prop('disabled',false);
                                flag =1;
                                return false;
                                this.$Progress.fail();
                            }
                            vendors.push($(this).val());
                        }else if($(this).hasClass("amount")){
                            if ($(this).val() == '' || $(this).val() == 0) {
                                swal.fire({
                                        type: 'error',
                                        title: 'Amount can not be empty'
                                    });
                                $('.createBatch').prop('disabled',false);

                                flag =1;
                                return false;
                                this.$Progress.fail();
                            }
                            amount.push($(this).val());
                        }else if($(this).hasClass("purpose")){
                            if ($(this).val() == '') {
                                swal.fire({
                                        type: 'error',
                                        title: 'Purpose can not be empty'
                                    });
                                $('.createBatch').prop('disabled',false);

                                flag =1;
                                return false;
                                this.$Progress.fail();
                            }
                            purpose.push($(this).val());
                        }
                        });
                     });
                    if(flag == 0){
                        //vendors  = this.vendrs
                        $('#createBatch').prop('diabled',true);
                        var batch_name = $( "#batch_name" ).val();
                        var batch_name_ = $( "#batch_name_" ).val();
                        var batch_name = (batch_name == '') ? batch_name_ : batch_name;

                        axios.post('/api/createVendorBatch', {
                            vendorIds: vendors,
                            amounts: amount,
                            purposes: purpose,
                            batch_name: batch_name,
                        })
                            .then(res => {
                                if(res.data.status == 200){
                                    toast.fire({
                                        type: 'success',
                                        title: 'Vendor batch created successfully'
                                    });

                                    $('#payVendor').modal('hide');
                                    $('#paySingleVendor').modal('hide');

                                    that.$router.push('/viewVendorPaymentSheet/'+res.data.data.id);
                                }else{
                                    swal.fire({
                                        type: 'error',
                                        title: 'No vendor found'
                                    });
                                    $('.createBatch').prop('disabled',false);
                                }
                            })
                            .catch(err => {
                                this.$Progress.fail();
                                swal.fire({
                                    type: 'error',
                                    title: 'Error to load data'
                                });
                                $('.createBatch').prop('disabled',false);
                            });
                    }


            },searchData(){
                completeTable.search($("#customSearch").val()).draw();
            },
            selectDTRows(txt, obj){
                $("#btnPaymentTop").show();
                var rows = completeTable.rows({ page: 'current' }).nodes();
                if(txt == "All"){
                    if($(obj).hasClass("searched")){
                        completeTable.rows().deselect();
                        $(obj).parent().parent().find("a").removeClass("searched");
                        var rows = completeTable.rows({search: 'applied'}).nodes();
                        $('input[type="checkbox"]', rows).prop('unchecked', this.checked);
                        $(rows).removeClass("selected");
                        $(obj).removeClass("searched");
                        $(".fa-minus").hide();
                        $(".cstm-chkbx").show();
                        $(".check-holder input").prop("checked",false);
                        $("#btnPaymentTop").hide();
                        $(obj).parent().parent().parent().siblings('.drop-value-changer').html("Select Category");
                        this.vendrs = [];
                    }else{
                        $(obj).parent().parent().find("a").removeClass("searched");
                        $(obj).parent().parent().find("a").addClass("searched");
                        var rows = completeTable.rows({search: 'applied'}).nodes();
                        completeTable.rows().deselect();
                        completeTable.rows().select();
                        $('input[type="checkbox"]', rows).prop('checked', this.checked);
                        $(rows).addClass("selected");
                        $(obj).addClass("searched");
                        $(".check-holder input").prop("checked",true);
                        $(obj).parent().parent().parent().siblings('.drop-value-changer').html(txt);
                    }
                }else{

                    if($(obj).parent().parent().find(".all").hasClass("searched")){
                        $(obj).parent().parent().find(".all").removeClass("searched");
                    }
                    if($(obj).hasClass("searched")){
                        rows = completeTable.column(5).search("^"+txt+"$",true,false,true).rows({ 'search': 'applied' });
                        completeTable.column(5).search('').draw();
                        rows.deselect();
                        $(obj).removeClass("searched");
                        var sRowsSearched = $(".dropdown-menu li a.searched").size();
                        var cText = $(".dropdown-menu li a.searched").html();
                        if(sRowsSearched == 1){
                            $(".fa-minus").show();
                            $(".cstm-chkbx").hide();
                            $(obj).parent().parent().parent().siblings('.drop-value-changer').html(cText);
                        }else if(sRowsSearched == 0){
                            $(obj).parent().parent().parent().siblings('.drop-value-changer').html("Select Category");
                            $(".check-holder input").prop("checked",true);

                        }else{
                            $(".check-holder input").prop("checked",false);
                            $(".selection-custom-dropdown .drop-value-changer").html("Multiple Selections");
                        }
                    }else{
                        $(".cstm-chkbx").hide();
                        rows = completeTable.column(5).search("^"+txt+"$",true,false,true).rows({'search':'applied'});
                         completeTable.column(5).search('').draw();
                         completeTable.column(5).search(txt);

                        rows.select();
                        $('input[type="checkbox"]', rows).prop('checked', this.checked);
                        $(rows).addClass("selected");
                        $(obj).addClass("searched");
                        $(".check-holder input").prop("checked",false);
                        var sRowsSearched = $(".dropdown-menu li a.searched").length;
                        if(sRowsSearched >1){
                        $(obj).parent().parent().parent().siblings('.drop-value-changer').html("Multiple Selections");
                        }else{
                        var cHTML =$(obj).parent().parent().parent().siblings('.drop-value-changer').html(txt);
                        }
                    }
                }

            }
        }
    }
</script>
